import React, {Component} from "react";
import { Typography, Grid } from '@material-ui/core';

class KontenText extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }

    

    render() { 
        const {data} = this.props;
        return (
            <>
                <div className="text-konten-atas main-text-color">{this.props.title}</div>
                <div className="text-konten-bawah sub-title-color">{this.props.subTitle}</div>
            </>
        );
    }
}
 
export default KontenText;